import { PaginatedResponseMeta } from '../schemas/PaginatedResponseMetaSchema';

export type TokenPaginatedResponse<Data> = {
  data: Array<Data>;
  meta: PaginatedResponseMeta;
};

export async function fetchAllWithPaginationToken<Data>(
  asyncFn: (token?: string) => Promise<TokenPaginatedResponse<Data>>,
  { abortSignal }: { abortSignal?: AbortSignal } = {},
) {
  const records: Array<Data> = [];
  let token: string = '';

  do {
    const response: TokenPaginatedResponse<Data> = await asyncFn(token);
    records.push(...response.data);
    token = response.meta.next_token ?? '';
  } while (token !== '' && !abortSignal?.aborted);

  return records;
}
